import React from "react";
import "./Other BSD1.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsUpDownLeftRight} from "@fortawesome/free-solid-svg-icons";
import {faHouse} from "@fortawesome/free-solid-svg-icons";
import {faBed} from "@fortawesome/free-solid-svg-icons";
import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import Elyon9images from "../../../media/Other Clusters/Elyon 9/Elyon 9";
import Armontimages from "../../../media/Other Clusters/Armont/Armont";
import Terraviaimages from "../../../media/Other Clusters/Adora Primes/Terravia";
import Castiloimages from "../../../media/Other Clusters/Castilo/Castilo";

const Produk1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const Castilo = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281297520392&text=Halo+Jason%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Castilo)%20https://www.bsdcity-hiera.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Muzi = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281297520392&text=Halo+Jason%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Terravia)%20https://www.bsdcity-hiera.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Dento = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281297520392&text=Halo+Jason%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Eonna)%20https://www.bsdcity-hiera.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Yuga = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281297520392&text=Halo+Jason%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Armont)%20https://www.bsdcity-hiera.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="container">
      <div className="containercard1">
        <div className="card">
          <Slider {...settings}>
            {Castiloimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Castilo</div>
              <span>Tanpa DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">12</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon
              color="rgb(75, 75, 75)"
              icon={faArrowsUpDownLeftRight}
            />
            <span> : 84m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faHouse} />
            <span> : 110m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faShower} />
            <span>: 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Castilo} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Terraviaimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Terravia</div>
              <span>Tanpa DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">19</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon
              color="rgb(75, 75, 75)"
              icon={faArrowsUpDownLeftRight}
            />
            <span> : 144m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faHouse} />
            <span> : 232m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faBed} />
            <span>: 5+1</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faShower} />
            <span>: 4+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Muzi} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Elyon9images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Eonna</div>
              <span>Tanpa DP, Discount Up to 17%</span>
            </div>
            <div className="cicilan">
              <div className="angka">21</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon
              color="rgb(75, 75, 75)"
              icon={faArrowsUpDownLeftRight}
            />
            <span> : 162m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faHouse} />
            <span> : 265m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faBed} />
            <span>: 5+1</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faShower} />
            <span>: 7+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Dento} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Armontimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Armont</div>
              <span>Subsidi DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">24</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon
              color="rgb(75, 75, 75)"
              icon={faArrowsUpDownLeftRight}
            />
            <span> : 200m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faHouse} />
            <span> : 380m²</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faBed} />
            <span>: 5+1</span>
            <FontAwesomeIcon color="rgb(75, 75, 75)" icon={faShower} />
            <span>: 6+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Yuga} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Produk1;
